import { useTranslation, useLogout, useGo, useGetIdentity, useOne, useList } from "@refinedev/core";
import { FaPowerOff } from "react-icons/fa6";
import { IInvoice } from "interfaces";
import { useGoogleConnect } from "hooks/google/useGoogleConnect";
import { useGoogleIsAuthenticated } from "hooks/google/useGoogleAuthenticated";
import { IAuthUser } from "@auth/firebase/interfaces";
import { FaUserCircle } from "react-icons/fa";
import { Auth_Users } from "@graphql/schema.types";

export const ConfigUser = () => {
    const { translate } = useTranslation();
    const { mutate: logout } = useLogout();
    const go = useGo()
    const [connectGoogleHandler, activated] = useGoogleConnect()
    const { isLoading, data: googleAuth } = useGoogleIsAuthenticated()
    const { data: identity } = useGetIdentity<IAuthUser>();
    // logger.debug(identity)

    const { data } = useOne<Auth_Users>({
        resource: "auth_users",
        id: identity?.user_id,
        meta: {
            fields: [
                'id',
                'uid',
                'display_name',
                'first_name',
                'other_names',
                'surname',
                'second_surname',
                'email',
                'phone_number',
                {
                    'service_user': [{ 'plan': ['name'] }]
                }

            ],
        }
    });

    const user = data?.data;
    // logger.debug("user: ", user);

    const composeName = user ? [user.first_name, user.other_names, user.surname, user.second_surname].filter(e => !!e).join(" ") : ""
    const fullName = composeName || user?.display_name;
    const plan = user?.service_user?.plan?.name || 'N/A';

    const { data: dataInvoice, isLoading: isLoadingInvoice } = useList<IInvoice>({
        resource: "invoice",
        sorters: [
            {
                field: 'updated_at',
                order: 'desc',
            },
        ],
        meta: {
            fields: [
                'id',
                'amount',
            ],
        }
    });

    // logger.debug("dataInvoice", dataInvoice, isLoadingInvoice);

    return <div className="flex flex-col px-4 pb-4 prose prose-h3:mt-0 prose-h3:mb-2 prose-p:mb-0 max-w-none">
        <div className="flex flex-col items-center justify-center text-center bg-[url('/img/config-landscape.svg')] bg-cover h-48 lg:h-32 relative mb-20">
            <h1 className="m-0 drop-shadow-lg md:drop-shadow-none mb-8 md:mb-0">{user?.display_name}</h1>
            <div className="avatar absolute md:left-0 bottom-0 -mb-24 md:ml-8 not-prose">
                <object data={identity?.photoURL!} type="image/jpeg" className="w-40 h-40 rounded-full p-2 bg-base-100">
                    <FaUserCircle className="w-full h-full" />
                </object>
            </div>
        </div>
        <div className="flex-row mt-6">
            <h3>{translate('page.config.plan')}</h3>
            <p className="text-base">{plan}</p>
        </div>
        <div className="divider" />
        <div className="flex-row">
            <h3>{translate('page.config.billing')}</h3>
            <div className="stat p-0">
                <div className="stat-title">{translate('page.config.balance')}</div>
                <div className="stat-value">{dataInvoice?.data?.[0]?.amount ?? '-'}</div>
                <div className="stat-actions">
                    <button className="btn btn-sm btn-secondary">{translate("page.config.withdraw")}</button>
                </div>
            </div>
        </div>
        <div className="divider" />
        <div className="flex-row">
            <h3>{translate('page.config.full-name')}</h3>
            <p className="text-base">{fullName ?? '-'}</p>
        </div>
        <div className="divider" />
        <div className="flex-row">
            <h3>{translate('page.config.email')}</h3>
            <p className="text-base">{user?.email ?? '-'}</p>
        </div>
        <div className="divider" />
        <div className="flex-row">
            <h3>{translate('page.config.mobile-phone')}</h3>
            <p className="text-base">{user?.phone_number ?? '-'}</p>
        </div>
        <div className="divider" />
        <div className="flex-row">
            <h3>{translate('page.config.requests')}</h3>
            <button className="btn btn-sm btn-secondary" onClick={() => go({ to: '/config/pqrs' })}>{translate("page.config.create-request")}</button>
        </div>
        {/* {accessToken == null && <span className="loading loading-spinner loading-lg"></span>} */}
        <div className="divider" />
        <div>
            <h1 className='text-lg font-bold'>{translate("common.google.title")}</h1>
            <fieldset className="fieldset max-w-xs">
                <legend>{googleAuth.authenticated ?
                    translate("common.google.refresh-integration") : translate("common.google.new-integration")}
                </legend>
                <button className="btn btn-primary" onClick={connectGoogleHandler}>
                    {googleAuth.authenticated ? translate("common.google.refresh-connect") : translate("common.google.new-connect")}
                </button>
            </fieldset>
        </div>
        <div className="mt-8 md:hidden">
            <button className='btn btn-ghost' onClick={() => logout()}>
                <FaPowerOff />{translate("common.logout")}</button>
        </div>
    </div>
}
